import { render, staticRenderFns } from "./QuickMove.vue?vue&type=template&id=1ba7ac5b&"
import script from "./QuickMove.vue?vue&type=script&lang=js&"
export * from "./QuickMove.vue?vue&type=script&lang=js&"
import style0 from "./QuickMove.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports